import * as yup from "yup"

export const validationSchema = yup.object().shape({
  mr_group_code: yup.string().label("Group asset code").required().min(2).max(3),
  mr_group_name: yup.string().label("Group asset name").max(100, "Must be 100 characters or less").required(  ),
  description: yup.string().label("Description").optional(),
  mr_group_id: yup.number().optional(),
  is_deleted: yup.boolean().optional()
})

export type ValidationSchemaType = yup.InferType<typeof validationSchema>
